<template>
  <ul class="list-group">
    <li :class="'m-0 p-0 list-group-item ' + orderingOption.class"
        v-for="orderingOption in tableOrderingOptionsList" :key="orderingOption.msg"
        v-on:click="$emit('select-ordering-column', orderingOption.msg)">{{orderingOption.msg}}</li>
  </ul>



</template>
<script>
export default {
  name: "TablesOrderingMenu",
  props: ["tableOrderingOptionsList"]

};
</script>
<style scoped>
</style>